import { useState } from 'react';
import {
  CalendarDays,
  FileText,
  Images,
  LayoutDashboard,
  Menu,
  Sparkles,
  Star,
  Users,
} from 'lucide-react';
import Sidebar from './Sidebar';
import Estadisticas from './Estadisticas';
import Clientes from './Clientes';
import Servicios from './Servicios';
import Imagenes from './Imagenes';
import InspiracionAdmin from './InspiracionAdmin';
import Opiniones from './Opiniones';
import Reservas from '../Reservas/Reservas';
import Contratos from '../Contratos/Contratos';
import AdminSesiones from '../../Sesion/AdminSesiones';
import styles from './Dashboard.module.css';

const TABS = [
  {
    id: 'estadisticas',
    label: 'Resumen',
    icon: LayoutDashboard,
    description: 'Visión general de tu negocio: métricas, ingresos y actividad reciente.',
  },
  {
    id: 'clientes',
    label: 'Clientes',
    icon: Users,
    description: 'Consultá y gestioná tu cartera de clientes.',
  },
  {
    id: 'servicios',
    label: 'Servicios',
    icon: Sparkles,
    description: 'Editá el precio, la descripción y las fotos de cada servicio.',
  },
  {
    id: 'imagenes',
    label: 'Imágenes',
    icon: Images,
    description: 'Cambiá la foto de presentación, las polaroids, el carrusel y las categorías.',
  },
  {
    id: 'reservas',
    label: 'Reservas',
    icon: CalendarDays,
    description: 'Mirá las reservas, filtrá por estado y actualizá cada pedido.',
  },
  {
    id: 'inspiracion',
    label: 'Inspiración',
    icon: Images,
    description: 'Subí y organizá las fotos de la galería de inspiración.',
  },
  {
    id: 'contratos',
    label: 'Contratos',
    icon: FileText,
    description: 'Órdenes, estados de pago y generación de contratos.',
  },
  {
    id: 'sesiones',
    label: 'Sesiones',
    icon: Images,
    description: 'Gestioná las sesiones y subí las fotos de cada una.',
  },
  {
    id: 'opiniones',
    label: 'Reseñas',
    icon: Star,
    description: 'Revisá y moderá las opiniones de tus clientes.',
  },
];

function Dashboard() {
  const [activeTab, setActiveTab] = useState('estadisticas');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const active = TABS.find((t) => t.id === activeTab) ?? TABS[0];

  const handleSelect = (id) => {
    setActiveTab(id);
    setSidebarOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'clientes':
        return <Clientes />;
      case 'servicios':
        return <Servicios />;
      case 'imagenes':
        return <Imagenes />;
      case 'inspiracion':
        return <InspiracionAdmin />;
      case 'reservas':
        return <Reservas />;
      case 'contratos':
        return <Contratos />;
      case 'sesiones':
        return <AdminSesiones />;
      case 'opiniones':
        return <Opiniones />;
      case 'estadisticas':
      default:
        return <Estadisticas />;
    }
  };

  return (
    <div className={styles.dashboard}>
      <Sidebar
        tabs={TABS}
        activeTab={activeTab}
        onSelect={handleSelect}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className={styles.main}>
        <header className={styles.topbar}>
          <button
            type="button"
            className={styles.menuButton}
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú de secciones"
            aria-expanded={sidebarOpen}
          >
            <Menu size={22} aria-hidden="true" />
          </button>

          <div className={styles.heading}>
            <h1 className={styles.title}>{active.label}</h1>
            <p className={styles.subtitle}>{active.description}</p>
          </div>
        </header>

        <main className={styles.content} data-tab={activeTab}>
          {renderContent()}
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
